import React from 'react';
import styled from 'styled-components';

const ButtonStyle = styled.button`
  background: ${(props) => (props.secondary ? props.theme.mainBrandColor : '')};
  color: ${(props) => (props.secondary ? props.theme.mainBrandColor : '')};
`;

const Button = ({
  children,
  secondary,
  className,
  fullWidth,
  loading,
  ...props
}) => (
  <ButtonStyle
    secondary={secondary}
    className={`button is-borderless has-text-weight-bold px-5 ${className} ${
      fullWidth && 'is-fullwidth'
    } ${loading ? 'is-loading' : ''} ${
      secondary ? 'is-secondary' : 'is-primary'
    }`}
    {...props}
  >
    {children}
  </ButtonStyle>
);

export default Button;
